import React from 'react';
import Button from 'mui/components/elements/DS_ButtonLink';
import useNewBooking from './useNewBooking';

const BookingButton = ({ title, buttonSize }) => {
  const { newBooking } = useNewBooking();

  const handleOnClick = () => {
    newBooking();
  };

  return <Button onClick={handleOnClick} title={title} buttonSize={buttonSize} />;
};

export default BookingButton;
